function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationRuleDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db8509"
    },
    d: "M28 35.746c0 2.211-1.79 4-4 4s-4-1.789-4-4a4 4 0 0 1 8 0zM26 11a1.999 1.999 0 1 1-4 0V7a1.999 1.999 0 1 1 4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "M33 33V16.8a9 9 0 0 0-9-9 9 9 0 0 0-9 9V33Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "M41 33c0 2.21-7.059 4-17 4-9.941 0-17-1.79-17-4s7.059-4 17-4c9.941 0 17 1.79 17 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "M7 33c0-2 8-9 8-12s18-3 18 0 8 10 8 12-34 2-34 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffe8a0",
      fillOpacity: 1,
      strokeWidth: 1.12972438
    },
    d: "M10.746 27.666c-.817.968-.81.97-1.613 1.932 1.467.926 7.646 4.539 15.261 4.539 4.296 0 9.433-1.504 14.308-4.727-.867-1.047-.87-1.053-1.542-1.836-11.801 7.448-23.313 1.86-26.414.092z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.13026905,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    cx: 37.057,
    cy: 34.625,
    rx: 8.677,
    ry: 7.938
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.4 103.9c-5.7 0-10.2 5-10.2 11.1s4.6 11.1 10.2 11.1c5.7 0 10.2-5 10.2-11.1.1-6.1-4.5-11.1-10.2-11.1zm36.5 0c-5.7 0-10.2 5-10.2 11.1s4.6 11.1 10.2 11.1c5.7 0 10.2-5 10.2-11.1s-4.5-11.1-10.2-11.1z",
    className: "st0",
    style: {
      fill: "#7289da"
    },
    transform: "translate(21.6 20.343) scale(.12571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.5 20h-134C44.2 20 35 29.2 35 40.6v135.2c0 11.4 9.2 20.6 20.5 20.6h113.4l-5.3-18.5 12.8 11.9 12.1 11.2 21.5 19V40.6c0-11.4-9.2-20.6-20.5-20.6Zm-38.6 130.6s-3.6-4.3-6.6-8.1c13.1-3.7 18.1-11.9 18.1-11.9-4.1 2.7-8 4.6-11.5 5.9-5 2.1-9.8 3.5-14.5 4.3-9.6 1.8-18.4 1.3-25.9-.1-5.7-1.1-10.6-2.7-14.7-4.3-2.3-.9-4.8-2-7.3-3.4-.3-.2-.6-.3-.9-.5-.2-.1-.3-.2-.4-.3-1.8-1-2.8-1.7-2.8-1.7s4.8 8 17.5 11.8c-3 3.8-6.7 8.3-6.7 8.3-22.1-.7-30.5-15.2-30.5-15.2 0-32.2 14.4-58.3 14.4-58.3 14.4-10.8 28.1-10.5 28.1-10.5l1 1.2c-18 5.2-26.3 13.1-26.3 13.1s2.2-1.2 5.9-2.9c10.7-4.7 19.2-6 22.7-6.3.6-.1 1.1-.2 1.7-.2 6.1-.8 13-1 20.2-.2 9.5 1.1 19.7 3.9 30.1 9.6 0 0-7.9-7.5-24.9-12.7l1.4-1.6s13.7-.3 28.1 10.5c0 0 14.4 26.1 14.4 58.3 0 0-8.5 14.5-30.6 15.2z",
    className: "st0",
    style: {
      fill: "#7289da"
    },
    transform: "translate(21.6 20.343) scale(.12571)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRuleDiscord);
export default __webpack_public_path__ + "static/media/notificationRuleDiscord.8c47370885925ad97cad96320a3de734.svg";
export { ForwardRef as ReactComponent };